<template>
  <div class="hidden md:contents">
    <slot />
  </div>
</template>
